// GLOBAL CUSTOM COMPONENTS
import { Paragraph } from "src/lib/components/salify-next-layout/default/components/Typography";
import { FlexBetween } from "src/lib/components/salify-next-layout/default/components/flex-box"; // CUSTOM UTILS LIBRARY FUNCTION
import { formatMoney } from "src/lib/utils";

// ==============================================================
const ListItem = ({ title, value, mb = 0.5, color = "grey.600" }) => {
  const missing = value === null || value === undefined || value === "";
  const formatted = missing ? "-" : formatMoney(value);
  return (
    <FlexBetween mb={mb}>
      <Paragraph color={color}>{title}:</Paragraph>
      <Paragraph fontWeight="700">{formatted || "-"}</Paragraph>
    </FlexBetween>
  );
};

export default ListItem;
